<template>
  <div class="register-container">
    <div class="register-card">
      <img src="../../assets/login/logotitle.jpg" alt="Logo" class="register-logo">
      <h2 class="register-title">注册账号</h2>
      <el-form
        ref="registerForm"
        :model="registerForm"
        :rules="registerRules"
        class="register-form"
        label-width="100px"
      >
        <el-form-item label="用户名" prop="username">
          <el-input v-model="registerForm.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="registerForm.password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input type="password" v-model="registerForm.confirmPassword"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit" class="register-button">注册</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'; // 引入axios进行HTTP请求
// 引入Vue Router的组件
// import { RouteLink as RouterLink } from 'vue-router';
import RSA from '../utils/RSAencrypt'
export default {
  data () {
    return {
      registerForm: {
        username: '',
        password: '',
        confirmPassword: ''
      },
      registerRules: {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
          { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: this.confirmPasswordValidator, trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    confirmPasswordValidator(rule, value, callback) {
      if (value !== this.registerForm.password) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    },
    handleSubmit() {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          this.registerUser();
        } else {
          console.error('表单验证失败');
          return false;
        }
      });
    },
    registerUser () {
      // 这里可以添加密码加密逻辑，例如使用RSA加密
      var oldPwd = this.registerForm.password
      var oldUsername = this.registerForm.username
      var oldConfirmPwd = this.registerForm.confirmPassword
      this.registerForm.password = RSA.RSAencrypt(this.registerForm.password)
      const { username, password } = this.registerForm

      this.$axios.post('/api/auth/register', { username, password })
        .then(response => {
          if (response.data.code === 200) {
            this.$message.success('注册成功')
            // 可能需要跳转到登录页面或其他页面
            this.$router.push({ path: '/' })
          } else {
            this.$message.error('注册失败：' + response.data.message)
            this.registerForm.password = oldPwd
            this.registerForm.confirmPassword = oldConfirmPwd
            this.registerForm.username = oldUsername
          }
        })
        .catch(error => {
          this.$message.error('注册请求失败')
          console.error('注册请求失败：', error)
        })
    }
  }
}
</script>

<style scoped>
.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: url('../../assets/login/logo-bj5.jpg') no-repeat center center/cover;
  overflow: hidden;
  position: relative;
}
.register-card {
  width: 100%;
  max-width: 400px;
  padding: 30px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
}
.register-logo {
  display: block;
  margin: 0 auto 20px;
  width: 120px;
  height: auto;
}
.register-title {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
  font-weight: bold;
}
.register-form {
  margin-bottom: 20px;
}
.login-footer {
  /* 确保登录页脚有足够的空间 */
  margin-top: 30px;
  text-align: left;
}

.register-link {
  font-size: 0.9em; /* 相对于页面字体大小 */
  color: #2154FA; /* 链接的主要颜色 */
  cursor: pointer;
  text-decoration: none;
  position: relative;
  overflow: hidden;
  transition: color 0.3s ease;
}

.register-link:hover {
  color: #000099; /* 鼠标悬浮时的颜色变化 */
  text-decoration: underline;
}

.register-link::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0;
  height: 2px; /* 下划线的厚度 */
  background: currentColor; /* 与文本颜色一致 */
  transition: width 0.3s ease;
}

.register-link:hover::after {
  width: 100%; /* 鼠标悬浮时下划线展开到全宽 */
}

/* 可以添加一些辅助样式，比如阴影或圆角 */
.register-link {
  display: inline-block;
  margin: 5px 10px; /* 与周围元素保持一定间距 */
  padding: 5px 15px; /* 内边距 */
  border-radius: 15px; /* 圆角边框 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 轻微的阴影效果 */
  background-color: rgba(33, 84, 250, 0.1); /* 轻微的背景色，与主色调呼应 */
}

.register-link:hover {
  background-color: rgba(33, 84, 250, 0.2); /* 鼠标悬浮时更深的背景色 */
}

.register-button {
  display: inline-block;
  padding: 10px 110px; /* 增加水平方向的内边距，使按钮更长 */
  font-size: 16px; /* 字体大小 */
  color: #ffffff; /* 文字颜色 */
  background-image: linear-gradient(to right, #2154FA, #000099); /* 渐变背景色 */
  border: none; /* 无边框 */
  border-radius: 30px; /* 圆角边框 */
  cursor: pointer; /* 鼠标悬停时显示手形图标 */
  text-decoration: none; /* 移除下划线 */
  transition: background-image 0.3s ease, transform 0.2s ease; /* 平滑过渡效果 */
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2); /* 添加阴影 */
  outline: none; /* 点击时不显示轮廓 */
}

.register-button:hover {
  background-image: linear-gradient(to right, #000099, #2154FA); /* 鼠标悬浮时的渐变背景色 */
  transform: translateY(-2px); /* 轻微提升 */
}

.register-button:active {
  transform: translateY(-1px); /* 按下时的轻微效果 */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15); /* 阴影稍微变小 */
}
</style>



// WEBPACK FOOTER //
// src/components/login/Register.vue